export type AuxiliarMeta = {
  id: string | null
  name?: string | null
  code?: string | null
}

function load(model?: Partial<AuxiliarMeta> | null): AuxiliarMeta {
  return {
    id: model?.id ?? null,
    name: model?.name ?? null,
    code: model?.code ?? null,
  }
}

export const AuxiliarMeta = {
  load,
}
